import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import RcSteps, { Step, StepGroup } from '../rc-components/steps';
import ConfigContext from '../config-provider/ConfigContext';
const Steps = function Steps(props) {
    const { prefixCls: customizePrefixCls } = props;
    const { getPrefixCls } = useContext(ConfigContext);
    const prefixCls = getPrefixCls('steps', customizePrefixCls);
    return React.createElement(RcSteps, Object.assign({}, props, { prefixCls: prefixCls }));
};
Steps.displayName = 'Steps';
Steps.Step = Step;
Steps.StepGroup = StepGroup;
Steps.defaultProps = {
    iconPrefix: 'icon',
    current: 0,
};
Steps.propTypes = {
    prefixCls: PropTypes.string,
    iconPrefix: PropTypes.string,
    current: PropTypes.number,
};
export default Steps;
